import { createConsumer } from '@rails/actioncable';
import { config } from '../config';

export function createWebSocketConsumer(token) {
  return createConsumer(`${config.REACT_APP_PLAYBOOKUX_API_WEBSOCKET}?token=${token}`);
}
